import { TimeManagementRange } from 'types/app/timeManagement';

export const doesRangesOverlap = (ranges: TimeManagementRange[], newRange: TimeManagementRange) => {
  return ranges.some((range: TimeManagementRange) => {
    return newRange.min_guests <= range.max_guests && newRange.max_guests >= range.min_guests;
  });
};
